import PageSection from '../PageSection';

const ServiceHeader = () => {
  return (
    <PageSection backgroundColor='blue'>
        <div>
            <h1>Services</h1>
            <h3><i>Cash Only</i></h3>
        </div>
    </PageSection>
  );
}



export default ServiceHeader;